import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
import { computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router/dist/vue-router";
import { useStore } from "vuex";
const __default__ = {
  name: "menu-box"
};
export default /*@__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const router = useRouter(),
      route = useRoute(),
      store = useStore();
    const menuList = computed(() => {
      return store.getters.sidebarRouters;
    });
    const default_active = computed(() => {
      const default_ = router.getRoutes().filter(item => item.path === "/default");
      if (route.path === "/default" && default_ && default_.length > 0) {
        return `/${default_[0].name}`;
      } else {
        return route.path;
      }
    });
    watch(() => route.name, newVal => {
      (menuList.value || []).forEach(item => {});
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_menu = _resolveComponent("el-menu");
      return _openBlock(), _createBlock(_component_el_menu, {
        "default-active": default_active.value,
        router: "",
        class: "el-menu-vertical-demo"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: index
          }, [!item.hidden ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [item.children && item.children.length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [item.children.length === 1 ? (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 0,
            index: `/${item.children[0].path}`
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              class: _normalizeClass(["iconfont", item.meta.icon])
            }, null, 8, ["class"]), _createElementVNode("span", null, _toDisplayString(item.children[0].meta.title), 1)]),
            _: 2
          }, 1032, ["index"])) : item.children.length > 1 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
            key: 1,
            index: index.toString()
          }, {
            title: _withCtx(() => [_createVNode(_component_el_icon, {
              class: _normalizeClass(["iconfont", item.meta.icon])
            }, null, 8, ["class"]), _createElementVNode("span", null, _toDisplayString(item.meta.title), 1)]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (item_, index_) => {
              return _openBlock(), _createBlock(_component_el_menu_item, {
                key: index_,
                index: `/${item_.path}`
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item_.meta.title), 1)]),
                _: 2
              }, 1032, ["index"]);
            }), 128))]),
            _: 2
          }, 1032, ["index"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 64);
        }), 128))]),
        _: 1
      }, 8, ["default-active"]);
    };
  }
});